<template>
	<nav v-if="!mobile" class="app-nav">
		<group-picker
            :value="activeLocationGroup"
            :allow-create="true"
            @add="onGroupAdd"
            @change="onGroupChange"
        />

        <div
            :class="{ active: isCurrentRoutePath('groups') }"
            class="nav-item"
            @click="navigate({ name: 'group-list' })"
        >
            <icon src="group_work" />
            <tooltip>Groups</tooltip>
        </div>

        <div
            :class="{ active: isCurrentRoutePath('users') }"
            class="nav-item"
            @click="navigate({ name: 'user-list' })"
        >
            <icon src="supervisor_account" />
            <tooltip>Users</tooltip>
        </div>

        <create-group-modal
            ref="createGroupModal"
            @create="onGroupCreated"
        />
	</nav>
</template>


<script>
    import _ from 'lodash';
    import { browser, notifications } from 'pdk/services';
    import { actions as dashboardActions, getters as dashboardGetters } from 'dashboard-pdk/store';
    import { actions as appActions } from '@/store';
    import { GroupPicker } from '@/components/groups';
    import { CreateGroupModal } from '@/pages/groups/modals';


	export default {
        name: 'app-navigation',
        components: {
            CreateGroupModal,
            GroupPicker
        },
        data() {
            return {
                mobile: browser.getBrowser().mobile,
                viewingDashboards: false
            };
        },
        computed: {
            activeLocationGroup() {
                return this.viewingDashboards
                    ? this.$store.getters[dashboardGetters.ACTIVE_LOCATION_GROUP]
                    : null;
            }
        },
        created() {
            this.$router.afterEach(() => {
                this.update();
            });

            this.update();
        },
        methods: {
            // Actions
            setActiveGroup(locationGroupID) {
                this.$router.push({ name: 'group-dashboards', params: { locationGroupId: locationGroupID } });
            },
            navigate(route) {
                this.$router.push(route);
            },
            update() {
                this.viewingDashboards = this.isCurrentRoutePath('dashboards');
            },

            // Helpers
            isCurrentRoutePath(path) {
                return this.$route.path.substring(1).toLowerCase().startsWith(path.toLowerCase());
            },

            // Event handlers
            onGroupAdd() {
                this.$refs.createGroupModal.open();
            },
            onGroupChange(group) {
                this.setActiveGroup(group.locationGroupID);
            },
            onGroupCreated(e) {
                const groupLoad = this.$store.dispatch(dashboardActions.LOCATION_GROUPS_LOAD);
                const rolesLoad = this.$store.dispatch(appActions.USER_GROUP_ROLES_LOAD);

                notifications.open({
                    content: `Group created`
                });

                Promise.all([groupLoad, rolesLoad]).then(() => {
                    this.setActiveGroup(e.group.locationGroupID);
                });
            }
		}
	};
</script>

<style lang="scss">
@import '~@/assets/styles/references';


.app-nav { display: flex; flex-direction: row; height: $app-bar-height; justify-content: center; align-items: center;
    .group-picker { margin-right: gx(1); }

    .dropdown-toggle { 
		a,
		button,
		.btn { padding-left: gx(1); padding-right: gx(2) !important; background-color: color(black, state-bg); color: white; border-radius: $border-radius;
            &:hover,
            &:focus { background-color: color(black, divider); }
			&::after { position: absolute; right: gx(1) - 3px; top: 50%; margin-top: -3px; display: block; width: 0; height: 0; content: ""; border-top: 5px solid; border-right: 5px solid transparent; border-bottom: 0; border-left: 5px solid transparent; }
		}
		.btn { text-transform: none; }
		.btn-content { border-left: 0; border-right: 0; }
		.btn-label { padding-right: 0; text-align: left; width: 160px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;
			&:first-child { padding-left: 0; }
		}
		.btn-icon { border-radius: 0; font-size: 18px; }
	}

    .nav-item { display: flex; height: $app-bar-height; cursor: pointer; padding: 0 gx(0.75); align-items: center; justify-content: center; border-bottom: 3px solid transparent;
        &.active { background-color: color(black, state-bg); border-bottom-color: color(white);
            &:hover,
            &:focus { border-bottom-color: color(white); }
        }

        &:hover,
        &:focus { border-bottom-color: color(white, hint); }
    }
}
</style>
